/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface RealtimeRecognitionDisplay
 */
export interface RealtimeRecognitionDisplay {
  /**
   *
   * @type {string}
   * @memberof RealtimeRecognitionDisplay
   */
  direction: RealtimeRecognitionDisplayDirectionEnum;
}

export const RealtimeRecognitionDisplayDirectionEnum = {
  Ltr: 'ltr',
  Rtl: 'rtl',
} as const;

export type RealtimeRecognitionDisplayDirectionEnum =
  typeof RealtimeRecognitionDisplayDirectionEnum[keyof typeof RealtimeRecognitionDisplayDirectionEnum];
